module.exports = __webpack_public_path__ + "img/bg-safety-speed-03.png";